import { NavLink } from 'react-router-dom';

/* Tab nav shown at the top of every admin section page,
   so the admin can switch between Trainings / Portfolio / Career
   without logging in again. */
export default function AdminNav({ active }) {
  const tabs = [
    { key: 'trainings', label: 'Trainings & Workshops', to: '/admin/trainings' },
    { key: 'portfolio', label: 'Portfolio', to: '/admin/portfolio' },
    { key: 'careers', label: 'Careers', to: '/admin/careers' },
    { key: 'internships', label: 'Internship Applications', to: '/admin/internships' },
  ];

  return (
    <div className="adm-nav">
      {tabs.map((t) => (
        <NavLink
          key={t.key}
          to={t.to}
          className={`adm-nav__tab ${active === t.key ? 'adm-nav__tab--active' : ''}`}
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  );
}
